import axios from "axios";

const state = {
  list: []
};

const getters = {
  presets: state => state.list
};

const actions = {
  async fetchPresets({ commit }) {
    const response = await axios.get(process.env.VUE_APP_API_URL + "/presets/list");
    commit("SET_PRESETS", response.data.presets);
  }
};

const mutations = {
  SET_PRESETS(state, presets) {
    state.list = presets;
  },
  REMOVE_PRESET(state, id) {
    state.list = state.list.filter(p => p._id != id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
